const MONTHS = ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'];
const WEEKDAYS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

export interface ClockHandle {
  stop(): void;
}

export function mountClock(root: HTMLElement): ClockHandle {
  root.classList.add('wTimer');
  root.innerHTML = '';
  const dateLine = document.createElement('div');
  dateLine.className = 'wTimerDate';
  const weekdayLine = document.createElement('div');
  weekdayLine.className = 'wTimerWeekday';
  const timeLine = document.createElement('div');
  timeLine.className = 'wTimerTime';
  root.append(weekdayLine, dateLine, timeLine);

  let timer: ReturnType<typeof setInterval> | null = null;

  function update(): void {
    const now = new Date();
    weekdayLine.textContent = WEEKDAYS[now.getDay()] ?? '';
    dateLine.textContent = `${now.getDate()} ${MONTHS[now.getMonth()] ?? ''} ${now.getFullYear()}`;
    timeLine.textContent = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  }

  function start(): void {
    if (timer) return;
    update();
    timer = setInterval(update, 1000);
  }
  function stop(): void {
    if (timer) clearInterval(timer);
    timer = null;
  }

  start();
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });

  return { stop };
}
